import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { CpMarketplaceApiService } from '../../../services/cp-marketplace-api.service';
import { SharedDataService } from '../../../services/shared-data.service';
import { ISSUER_MESSAGES } from 'src/app/messages';
import { AllDocsAdditionalData, DocumentAdditionalDataValidity, DocumentKeys } from 'appRootPath/models/commercial-papers.model';
import { getCalendarDateObj, getDateFromCalendarObj, isWeekendAndHolidayDisabled } from 'appRootPath/utils';
import { API_DATE_FORMAT, UI_DATE_FORMAT_MAP } from 'appRootPath/shared/global-meta-data';
import * as moment from 'moment';
import { CpDocumentationActionsService } from 'appRootPath/services/cp-documentation-actions.service';

@Component({
  selector: 'app-dcn-additional-data',
  templateUrl: './dcn-additional-data.component.html',
  styleUrls: ['./dcn-additional-data.component.scss']
})

export class DcnAdditionalDataComponent implements OnInit {
  dcnForm: FormGroup;

  @Input() docKey: DocumentKeys;
  @Input() issueId;
  @Input() prefillData: DcnAdditionalData;
  @Input() docDateValidityMap: DocumentAdditionalDataValidity | null;

  issuerUserName;

  looDateObj;
  looDateFormatted;
  issueValueDateObj;
  issueValueDateFormatted;
  isWeekendAndHolidayDisabled = isWeekendAndHolidayDisabled;

  constructor(
    private dcnFB: FormBuilder,
    public activeModal: NgbActiveModal,
    private toastr: ToastrService,
    private apiService: CpMarketplaceApiService,
    private sharedData: SharedDataService,
    private documentationService: CpDocumentationActionsService
  ) { }

  /**
   * Angular init lifecycle hook. Initialize the issuer name and the DCN form.
   */
  ngOnInit() {
    this.issuerUserName = this.setIssuerUserName();
    this.initDcnForm();
    [this.looDateFormatted, this.looDateObj, this.issueValueDateFormatted, this.issueValueDateObj] =
      this.documentationService.initDatesForValidation(this.docDateValidityMap);
  }

  /**
   * Returns the logged in user's username from session storage.
   */
  setIssuerUserName() {
    return this.sharedData.getUserDataFromLS().username || '';
  }

  /**
   * Initialises DCN Form with the prefil data if it exists.
   */
  initDcnForm() {
    this.dcnForm = this.dcnFB.group({
      issue_reference: (this.prefillData && this.prefillData.issue_reference) || '',
      issuer_dealer_name: (this.prefillData && this.prefillData.issuer_dealer_name) ||
        this.issuerUserName,
      document_date: (this.prefillData && this.prefillData.document_date) ?
        getCalendarDateObj(moment(this.prefillData.document_date).toDate()) :
        null
    });
  }

  /**
   * Post the additional data for the current issue ID and document to the server
   */
  postDcnAdditionalData(dcnFormData) {
    if (this.dcnForm.invalid) {
      this.toastr.warning(ISSUER_MESSAGES.INVALID_FORM);
    } else {
      dcnFormData.document_date =
        getDateFromCalendarObj(dcnFormData.document_date).format(API_DATE_FORMAT);

      const dcnAdditionalData = {
        issue: this.issueId,
        deal_confirmation_note: Object.assign({}, dcnFormData)
      };

      this.apiService.postAdditionalData(dcnAdditionalData).
        subscribe((res: AllDocsAdditionalData) => {
          if (res.id) {
            this.toastr.success(ISSUER_MESSAGES.DCN_ADDITIONAL_DATA);
            this.activeModal.close(res.deal_confirmation_note);
          }
        });
    }
  }
}

interface DcnAdditionalData {
  issue_reference: string;
  issuer_dealer_name: string;
  document_date: string;
}
